import React from 'react';
import styled from 'styled-components';
import ErrorIcon from '../../assets/error-icon.svg';

const Wrapper = styled.div`
  display: flex;
  justify-content: start;
  align-items: center;
  background-color: #ffebee;
  border: 1px solid #ffcdd2;
  border-radius: 8px;
  padding: 12px 16px;
  margin-bottom: 8px;
  width: 100%;
  max-width: 100%;
`;

const Icon = styled.img`
  width: 24px;
  height: 24px;
  margin-right: 12px;
  flex-shrink: 0;
`;

const Message = styled.div`
  font-size: 14px;
  color: #c62828;
  text-align: left;
  line-height: 1.5;
`;

interface ErrorAlertProps {
  message: React.ReactNode;
  stoppedMessage?: React.ReactNode;
}

const ErrorAlert: React.FC<ErrorAlertProps> = ({ message, stoppedMessage }) => {
  if (!message && !stoppedMessage) {
    return null;
  }

  return (
    <Wrapper>
      <Icon src={ErrorIcon} />
      <Message>
        {message}
        {message && stoppedMessage && <br />}
        {stoppedMessage}
      </Message>
    </Wrapper>
  );
};

export default ErrorAlert;

